/* CUSTOM_THREADAUDIENCE_BY_CLAUDE (AIOPS c59cbc4588bc, Ryan 2026-09-16)
   ─────────────────────────────────────────────────────────────────────────────
   Settings → Admin: Customer Thread Audience — the JS half. Markup in
   snippets/rep-settings-thread-audience.liquid.

   ⛔ ITS OWN ASSET BECAUSE THE SECTION IS FULL — rep-quote-settings.liquid measured 259,893
   bytes (LF, which is how Shopify stores it) on 2026-09-16 against a 256 KB cap, so 2,251
   bytes of headroom. Same rule and the same precedent as rep-settings-parked-mail.js.

   ⛔ NOTHING IS DEFAULTED IN THE MARKUP. The checkbox ships with no `checked` attribute and the
   number box ships empty; both are filled from the server and Save is disabled until that lands.
   A failed load must never be able to look like "it is off" and then SAVE that over an armed
   switch — the parked-mail panel's rule, and it matters more here because the thing being
   overwritten decides who receives a customer email.

   ⚠️ IT IS THE ONLY PLACE THIS TURNS ON. The capability model keeps this route out of the agent
   registry entirely, so no bot can reach it; a build session may create the gate and never open
   it. That leaves exactly one door, and this is it.

   ⚠️ THE PANEL READS THE SERVER'S OWN `meaning` SENTENCE rather than composing its own. The
   worker already returns one line of plain English describing the live state, and a second
   opinion rendered here is how a screen starts disagreeing with the thing it is describing.

   Loaded deferred from the section after custom-rep-portal.js (which defines
   window.RepPortal.API); runs on DOMContentLoaded. showMsg / hideMsg are the section's two
   helpers, copied because they are IIFE-local there. */
(function () {
  'use strict';

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) {
    if (!el) return;
    el.className = 'rep-settings__message';
  }

  function initThreadAudience() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var on = document.getElementById('settings-threadaudience-on');
    var max = document.getElementById('settings-threadaudience-max');
    var btn = document.getElementById('settings-threadaudience-btn');
    var msg = document.getElementById('settings-threadaudience-msg');
    var state = document.getElementById('settings-threadaudience-state');
    if (!on || !max || !btn) return;

    /* The server's own sentence about the live state. Rendered verbatim. */
    function paint(data) {
      if (!state) return;
      state.textContent = (data && data.meaning) || '';
    }

    btn.disabled = true;
    (function load() {
      window.RepPortal.API.get('/admin/thread-audience-config').then(function (data) {
        var cfg = (data && data.config) || {};
        on.checked = cfg.replyAllOnCustomerThread === true;
        max.value = (cfg.maxExtraRecipients == null ? '' : String(cfg.maxExtraRecipients));
        paint(data);
        btn.disabled = false;
      }).catch(function () {
        showMsg(msg, 'Could not read the current setting - reload the page before saving, or you would save over it.', 'error');
      });
    })();

    btn.addEventListener('click', function () {
      hideMsg(msg);

      /* ⚠️ REFUSED HERE RATHER THAN NORMALISED. The worker refuses a bad dial too, but a panel
         that silently rewrote 99 to 6 would read on screen as the edit reverting itself. */
      var raw = String(max.value == null ? '' : max.value).trim();
      var n = raw === '' ? null : Number(raw);
      if (n !== null && (!Number.isInteger(n) || n < 0 || n > 50)) {
        showMsg(msg, 'The ceiling must be a whole number from 0 to 50.', 'error');
        return;
      }

      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'Saving...';

      var body = { replyAllOnCustomerThread: !!on.checked };
      /* An empty box means "leave the ceiling as it is", so the field is omitted — the worker
         merges field by field. It is NOT sent as 0, which is a real and very different choice. */
      if (n !== null) body.maxExtraRecipients = n;

      window.RepPortal.API.post('/admin/thread-audience-config', body).then(function (res) {
        var cfg = (res && res.config) || {};
        var was = (res && res.was) || {};
        var flipped = cfg.replyAllOnCustomerThread !== was.replyAllOnCustomerThread;
        var word = cfg.replyAllOnCustomerThread ? 'ON' : 'OFF';
        showMsg(msg, flipped
          ? ('Saved - reply-all on a customer thread is now ' + word + '. It takes effect on the next tracking notice; there is no preview.')
          : ('Saved - reply-all stays ' + word + '.'), 'success');
        on.checked = cfg.replyAllOnCustomerThread === true;
        max.value = (cfg.maxExtraRecipients == null ? '' : String(cfg.maxExtraRecipients));
        /* Re-read so the sentence under the button is the SERVER's, not one inferred from the
           POST's echo. Cheap, and it is the line a person will trust afterwards. */
        return window.RepPortal.API.get('/admin/thread-audience-config').then(paint).catch(function () {});
      }).catch(function (e) {
        showMsg(msg, 'Could not save. ' + ((e && e.message) ? e.message : ''), 'error');
      }).then(function () {
        btn.disabled = false;
        btn.textContent = orig;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThreadAudience);
  } else {
    initThreadAudience();
  }
})();
